module.exports = __webpack_public_path__ + "img/cam_8_on.9c7a18f8.png";